<template>
  <keep-alive>
    <div class="wrap-device-list">
      <div class="wrap-device-list_bg">
        <div class="wrap-device-list_row">
          <div
            :class="(filters_state === true)? 'device-list_fiters_toggler--active' : 'device-list_fiters_toggler'"
            @click="toggleFiltersState"
          >
            <span
              :class="(filters_state === true)? 'mdi mdi-filter-remove' : 'mdi mdi-filter'"
              @click="toggleFiltersState"
            />
            <span class="device-list_fiters_toggler_text">{{ (filters_state)? translate('filter.hide') : translate('filter.show') }}</span>
          </div>

          <div
            class="device_groups"
            :class="(filters_state === true)? 'device-list_fiters_is--show' : 'device-list_fiters_is--hidden'"
          >
            <sis-select
              :options="opt_device_groups"
              :options_limit="100"
              :label="translate('device.group.many')"
              :placeholder="translate('device.group.select_group')"
              v-model="filter.group"
              :multiple="true"
              :flat="true"
              :close_on_select="false"
              clear-on-select="true"
              :hide_selected="true"
              :preserveSearch="true"
              :max_height="165"
              :select-label="translate('select_enter')"
              :noresult="translate('group.not_found')"
              :disabled="filter.custom_list.length > 0"
              @input="change_group"
            />
          </div>


          <div
            class="users_list"
            :class="(filters_state === true)? 'device-list_fiters_is--show' : 'device-list_fiters_is--hidden'"
            v-if="opt_custom_list.length > 0"
          >
            <sis-select
              :options="opt_custom_list"
              :options_limit="100"
              :label="translate('device.group.list')"
              :placeholder="translate('device.group.select_list')"
              v-model="filter.custom_list"
              :multiple="true"
              :flat="true"
              :close_on_select="false"
              clear-on-select="true"
              :hide_selected="true"
              :preserveSearch="true"
              :max_height="165"
              :select-label="translate('select_enter')"
              :noresult="translate('group.not_found')"
              :disabled="filter.group.length > 0"
              @input="change_group"
            />
          </div>

          <div
              class="versions_list"
              :class="(filters_state === true)? 'device-list_fiters_is--show' : 'device-list_fiters_is--hidden'"
              v-if="$store.getters.getPermissions.permissionGod === true"
          >
            <sis-select
              :options="firmwares_options"
              v-model="firmwares_filter"
              :disable_branch_nodes="true"
              :multiple="true"
              :loading="false"
              :label="translate('firmwares_versions')"
              :placeholder="translate('firmwares_versions')"
              @open="loadOptions()"
            />

          </div>

          <div
            class="manage_block"
            :class="(filters_state === true)? 'device-list_fiters_is--show' : 'device-list_fiters_is--hidden'"
            v-if="(permissions.permissionNotifications === true) || (permissions.editDeviceList === true)"
          >
            <div class="form-group" v-if="number_checked > 0">
              <label>
                {{ this.translate('manage') }}
              </label>
              <div class="manage">
                <span
                  v-if="false"
                  class="manage_btns mdi mdi-file-hidden btn btn-primary btn-fill"
                  @click.prevent="add_task"
                >
                  {{ translate('task.new') }}
                </span>

                <div class="manage_btns datepicker"
                  v-if="false">
                  <date-picker
                    v-model="dateReport"
                    type="datetime"
                    range
                    valueType="X"
                    :confirm="true"
                    @confirm="getReport"
                    :confirmText="translate('config.apply')"
                    :default-value="new Date().setHours(0, 0, 0, 0)"
                    :disabled-date="disabledTwoMonth"
                    :disabled="loading"
                    @close="loading=true"
                  >
                    <template v-slot:input>
                      <span
                        class="mdi mdi-file-hidden btn btn-primary btn-fill"
                        @click.prevent="report">{{ translate('report.one') }}
                      </span>
                    </template>
                  </date-picker>
               </div>

               <span
                 v-if="permissions.permissionNotifications"
                 class="manage_btns mdi mdi-bell btn btn-primary btn-fill"
                 @click.prevent="notifications"
               >
                 {{ translate('notification.one') }}
               </span>

               <span
                 v-if="permissions.editDeviceList"
                 class="manage_btns mdi mdi-format-list-bulleted-square btn btn-primary btn-fill"
                 @click.prevent="custom_device_list('new')"
               >
                 {{ translate('custom.new_custom_list') }}
               </span>

               <span
                 v-if="permissions.editDeviceList"
                 class="manage_btns mdi mdi-format-list-bulleted-square btn btn-primary btn-fill"
                 @click.prevent="custom_device_list('add')"
               >
                 {{ translate('custom.add_device_in_list') }}
               </span>
              </div>
            </div>
          </div>

          <div
          class=""
          :class="(filters_state)? 'reset-filters-wrap' : 'reset-filters-wrap--hidden'"
          >
            <button
              class="reset-filters-btn  mdi-refresh mdi"
              :class="(status_filter())? '' : 'is--no-active'"
              @click.prevent="reset_filter"
            >
              {{ translate('filter.reset') }}
            </button>

            <span
                class="btn btn-success  mdi mdi-file-excel"
                @click.prevent="get_csv()"
            >
              Save to CSV
            </span>

            <button
                v-if="$store.getters.getPermissions.permissionGod === true"
                class="show_hidden mdi mdi-cog"
                @click.prevent="show_settings()"
            >
              {{ translate('settings.many') }}
            </button>
          </div>
        </div>
      </div>
      <div class="response_table">
        <table>
          <thead
            ref="tableHead"
            class="table-device-list_bg"
            :class="(filters_state)? 'device-list_fiters_is--show' : 'device-list_fiters_is--hidden'"
          >
            <tr>
              <th scope="col" class="checkbox_table">
                <input type="checkbox" v-model="checkall" @change="checkAll">
                <span v-if="number_checked > 0">{{ number_checked }}</span>
              </th>
              <th
                scope="col"
                class="status table-device-list_mob-filters"
              >
                <toggle-switch-device-status
                  v-model="filter.status"
                  :disabled="false"
                  :name="name"
                  @toggle="change_status"
                  @selected="selectedMethod()"
                />
              </th>
              <th
                scope="col"
                class="table-device-list_mob-filters"
              >
                <tag-list-popup
                  v-model="filter.name"
                  :label="'ID / ' + translate('device.name')"
                  @input="change_input"
                />
              </th>

              <th scope="col" class="custom_tag sim_status">
                Simcard Status
              </th>

              <th
                scope="col"
                class="table-device-list_mob-filters"
              >
                <tag-list-popup
                  v-model="filter.place"
                  :label="translate('device.place')"
                  @input="change_input"
                />
              </th>
              <th
                scope="col"
                class="table-device-list_mob-filters"
              >
                <tag-list-popup
                  v-model="filter.desc"
                  :label="translate('device.desc')"
                  @input="change_input"
                />
              </th>
              <th
                scope="col"
                class="table-device-list_mob-filters"
              >
                <tag-list-popup
                  v-model="filter.ip"
                  :label="translate('IP')"
                  @input="change_input"
                />
              </th>
              <th scope="col" class="custom_tag uptime">
                Uptime
              </th>
              <th style="width: 15px" />
            </tr>

            <tr>
              <th v-if="filter_result" >
                {{ translate('filter.result') }}:
                {{ filter_result.devices + ' ' + translate('filter.devices')}},
                {{ filter_result.pages + ' ' + translate('filter.pages')}}
              </th>
            </tr>

            <tr>
              <th
                v-if="head_tr"
                class="group_res"
                @click="group_device('device_group/' + head_tr.group_id)"
                v-html="head_tr.name"
              >
              </th>
            </tr>

          </thead>
          <tbody
            ref="tableDevice"
            style="position: relative; z-index: 1"
            @scroll.passive="paint_chart($event)"
          >
            <tr
              v-if="load"
              style="border:none; background-color:  transparent;"
            >
              <td> <scale-loader /> </td>
            </tr>
            <device-item
              v-for="(item,index) in trs"
              ref="myDevice"
              class="device_item"
              :key="index"
              :index="index"
              :item="item"
              @check="resetCheck"
            />
            <tr
              v-if="afterload"
              style="border:none; background-color:  transparent;"
            >
              <td> <scale-loader /> </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </keep-alive>
</template>
<script>
import DeviceItem from './DeviceItem.vue'
import DeviceManage from './DeviceManage.vue'
import DatePicker from 'components/UIComponents/Datepicker2/index.js';

import ToggleSwitchDeviceStatus from 'components/UIComponents/ToggleSwitch/ToggleSwitchDeviceStatus.vue'
import TagListPopup from 'components/UIComponents/Tags/TagListPopup.vue'
import SisSelect from 'components/UIComponents/Inputs/SisSelect.vue'
import NotificationEdit from "../../General/Notification/Notification/NotificationEdit";

import ModalCustomDeviceList from '../CustomDeviceList/ModalCustomDeviceList'
import ModalSettingsDeviceList from "@/views/Dashboard/common/Device/DeviceList/ModalSettingsDeviceList.vue";

export default {
  name: 'DeviceList',
  components: {
    DatePicker,
    DeviceItem,
    SisSelect,
    ToggleSwitchDeviceStatus,
    TagListPopup,

  },
  data () {
    return {
      loading: true,
      range: false,
      cur_item: {},
      load: true,
      top: 0,
      ids: [],
      interval_update: null,
      afterload: false,
      group_cnt: {},
      tableData: {},
      trs: [],
      timer: null,
      timer_res: null,
      name: '',
      cur_page: 1,
      next_page: 1,
      pages: 0,
      timer_chart: null,
      menuData: {},
      rendList: [],
      resizeList: [],
      checkall: false,
      was_checkall: false,
      uncheckList: {},
      filter: {},
      head_tr: {
        name: '',
        group_id: 0
      },
      group_head: [],
      status_option: [],
      filters_state: (this.localStorage.getItem('filters_state') !== null) ? (this.localStorage.getItem('filters_state') === 'true') : true,
      date: [],
      dateReport: [],
      number_checked: 0,
      filter_result: '',
      firmwares_options: [],
      firmwares_filter: []
    }
  },
  computed: {
    opt_custom_list () {
      return this.$store.getters.getCustomListTree
    },
    opt_device_groups () {
      return this.$store.getters.getDeviceGroupsTree
    },
    proveCopy () {
      return (navigator.clipboard !== undefined)
    },
    permissions(){
      return this.$store.getters.getPermissions
    }
  },

  watch: {
    firmwares_filter(){
      let filter = {}
      for (let firmwares of this.firmwares_filter){
        let item = firmwares.split(':')
        if (!filter[item[0]]){
          filter[item[0]] = []
        }
        filter[item[0]].push(item[1])
      }
      this.filter.versions = filter
    },
    'filter.versions':{
      handler: function () {
        this.change_input()
      }
    },
    'filter.custom_list':{
      handler: function () {
        if (this.filter.custom_list.length > 0) {
          this.filter.group = []
        }
      }
    },
    'filter.group':{
      handler: function () {
        if (this.filter.group.length > 0) {
          this.filter.custom_list = []
        }
      }
    },
    opt_device_groups () {
      this.$nextTick( () => {
        if (this.group_head.length > 0) {
          this.group_head[0].$el.style.display = 'none'
          if (this.$refs.tableDevice.scrollTop <= 50) {
            this.head_tr.name = this.group_head[0].$el.firstChild.innerHTML
            this.head_tr.group_id = this.group_head[0].item.group_id
          }
        }
      } )
    },
    tableData () {
      this.assembly_trs()

      this.load = false
      this.afterload = false
      this.$nextTick(this.mountItem)
    }
  },
  created () {
    this.init()
    // this.loadOptions()
    window.addEventListener('resize', this.handleResize)
  },
  activated () {
    this.$refs.tableDevice.scrollTop = this.top
    if (this.$store.getters.getDeviceListChange) {
      this.init()
      this.$store.commit('setDeviceListChange', false)
    } else {
      clearInterval(this.interval_update)
      this.interval_update = setInterval(this.update_status, this.$store.getters.getDeviceListUpdate)
    }

    window.addEventListener('resize', this.handleResize)
  },

  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
  },

  deactivated () {
    this.top = this.$refs.tableDevice.scrollTop
    clearInterval(this.interval_update)
    window.removeEventListener('resize', this.handleResize)
  },

  methods: {
    get_csv(){
      this.$http.v1.getDevicesCSV(this.filter,(response) => {
        let blob = new Blob([response.data])
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'Device_list' + '_' + this.get_date(+new Date()/1000) + '.csv'
        link.click()
        this.loading = false
      })
    },
    async loadOptions() {
      if (this.firmwares_options.length > 0) return
      await this.$http.v1.getFirmWareVersions((response) => {

        let list = []
        for (let key in response.data) {
          let item = {id: key, label: key, children: []}
          for (let ver of response.data[key]) {
            item.children.push({id: key + ':' + ver, label: key + ':' + ver})
          }
          list.push(item)
        }

        this.firmwares_options = list
      })
    },
    assembly_trs: function () {
      let trs = [] // 0 - название группы, 1 - элемент
      let t = {}
      let number = 0
      let count = 0
      for (let i in this.tableData) {
        t = {
          'type': 0,
          id: i,
          count: this.group_cnt[i].count,
          online: +this.group_cnt[i].online,
          group_id: this.group_cnt[i].group_id
        }
        trs.push(t)
        for (let j in this.tableData[i]) {
          if (this.tableData[i][j].checked) {
            number++
          }
          if ((this.online && this.tableData[i][j].status) || !this.online) {
            this.tableData[i][j].type = 1
            trs.push(this.tableData[i][j])
          }
          count++
        }
      }
      this.checkall = (count === number);
      this.number_checked = number
      this.$set(this, 'trs', trs)
    },
    group_device(url){
      this.$router.push(url)
    },
    getReport () {
      let filter = this.filter

      if(this.was_checkall) {
        filter['not_id'] = Object.keys(this.uncheckList)
      }
      else {
        let checkedList = []
        for (let i in this.tableData) {
          for (let j in this.tableData[i]) {
            if (this.tableData[i][j].checked) {
              checkedList.push(this.tableData[i][j].device_id)
            }
          }
        }
        if (checkedList.length === 0)  {
          this.global_notify('danger', this.translate('device.no_chosen'))
          this.loading = true
          return false
        } else {
          filter['ids'] = checkedList
        }
        }
    },
    disabledTwoMonth(dateReport) {
        const today = new Date();
        return dateReport > new Date(today.getTime()) || dateReport < new Date(today.getTime() - 60 * 24 * 3600 * 1000);
    },
    update_status () {
      this.date = new Date()
      for (let i = 1; i <= this.cur_page; i++) {
        this.$http.v1.getDevices(i, this.filter, (response) => {
          this.pages = response.data.pages
          this.group_cnt = Object.assign(this.group_cnt, {...response.data.groups})
          this.filter_result = {devices: response.data.count, pages: response.data.pages}
          for (let i in response.data.devices) {
            if (this.tableData[i] === undefined) {
              this.tableData[i] = {}
            }
            for (let j in response.data.devices[i]) {
              if (this.tableData[i][j] === undefined) {
                this.tableData[i][j] = {}
              }
              for (let k in response.data.devices[i][j]) {
                this.tableData[i][j][k] = response.data.devices[i][j][k]
              }
              this.tableData[i][j].offline = response.data.devices[i][j].offline
            }
          }
        })
      }
    },
    change_group () {
      this.change_input()
    },
    change_status (name, value) {
      this.filter.status[name] = value
      this.change_input()
    },

    handleResize () {
      if (this.timer_res !== null) {
        clearTimeout(this.timer_res)
      }
      this.timer_res = setTimeout(() => { this.resizeList = [...this.$refs.myDevice]; this.paint_chart() }, 300)
    },
    checkAll () {
      for (let i in this.tableData) {
        for (let j in this.tableData[i]) {
          this.$set(this.tableData[i][j], 'checked', this.checkall)
        }
      }

      this.assembly_trs()
    },
    resetCheck (check, item) {
      this.tableData[item.group_id][item.id].checked = check

      this.assembly_trs()
    },
    status_filter () {
      for (let i in this.filter) {
        if (i === 'status') {
          for (let j in this.filter.status) {
            if (this.filter.status[j]) {
              return true
            }
          }
        }else if(i === 'versions') {
          if (Object.keys(this.filter[i]).length > 0 ){
            return true
          }
        }else {
          if (this.filter[i].length > 0) {
            return true
          }
        }
      }
      return false
    },
    get_filter () {
      let arr = {server: [], group: [], desc: [], place: [], name: [], ip: [], custom_list:[], versions: {}, status: { online: true, backup: false, blocked: false }}
      let res = {}

      let filter = JSON.parse(this.localStorage.getItem('filter_devices'))

      if (filter !== null) {
        for (var i in arr) {
          if (filter[i] !== undefined) {
            res[i] = filter[i]
          } else {
            res[i] = arr[i]
          }
        }
      } else {
        res = arr
      }
      return res
    },

    init () {
      this.filter = this.get_filter()
      this.date = new Date()
    },

    paint_chart () {
      let tmpRend = []
      let table = this.$refs.tableDevice
      for (let i in this.group_head) {
        if (this.group_head[i].$el.offsetTop <= (table.scrollTop - this.group_head[i].$el.clientHeight)) {
          this.head_tr.name = this.group_head[i].$el.firstChild.innerHTML
          this.head_tr.group_id = this.group_head[i].item.group_id
        }
      }
      for (let i in this.resizeList) {
        if ((this.resizeList[i].$el.offsetTop > (table.scrollTop - 40)) && this.resizeList[i].$el.offsetTop < (table.scrollTop + table.clientHeight + 40)) {
          if (this.resizeList[i].chartStatus === true) {
            this.resizeList[i].resize = !this.resizeList[i].resize
          }
        } else {
          tmpRend.push(this.resizeList[i])
        }
      }

      if (tmpRend.length > 0) {
        this.resizeList = [...tmpRend]
      }

      tmpRend = []
      for (let i in this.rendList) {
        if ((this.rendList[i].$el.offsetTop > (table.scrollTop - 40)) && this.rendList[i].$el.offsetTop < (table.scrollTop + table.clientHeight + 40)) {
          this.rendList[i].chartStatus = true
        } else {
          tmpRend.push(this.rendList[i])
        }
      }
      this.rendList = tmpRend
      if ((table.scrollTop >= table.scrollHeight - (table.clientHeight * 3)) && !this.afterload) {
        if (this.next_page) {
          this.add_device_in_list()
        }
      }
    },

    mountItem () {
      if (this.trs.length === 0) {
        this.head_tr.name = ''
        this.head_tr.group_id = null
        return false
      }
      let length = (this.$refs.myDevice.length < 25) ? this.$refs.myDevice.length : 25

      for (let i = 0; i < length; i++) {
        this.$refs.myDevice[i].chartStatus = true
      }
      if (length < this.$refs.myDevice.length) {
        for (let i = 25; i < this.$refs.myDevice.length; i++) {
          this.rendList.push(this.$refs.myDevice[i])
        }
      }
      for (let i = 0; i < this.$refs.myDevice.length; i++) {
        if (this.$refs.myDevice[i].item.type === 0) {
          this.group_head.push(this.$refs.myDevice[i])
        }
      }
      if (this.group_head.length > 0) {
        this.group_head[0].$el.style.display = 'none'
        if (this.$refs.tableDevice.scrollTop <= 50) {
          this.head_tr.name = this.group_head[0].$el.firstChild.innerHTML
          this.head_tr.group_id = this.group_head[0].item.group_id
        }
      }
    },
    change_input () {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(this.get_device, 1000)
    },

    reset_filter () {
      this.filter = {server: [], group: [], desc: [], place: [], name: [], ip: [], custom_list:[], versions: {}, status: { online: false, backup: false, blocked: false }}
      this.firmwares_filter = []
      this.change_input()
    },

    get_device () {
      this.load = true
      this.group_head = []

      clearInterval(this.interval_update)
      this.interval_update = setInterval(this.update_status, this.$store.getters.getDeviceListUpdate)
      this.rendList = []

      let filter = this.filter
      this.$store.dispatch('setDeviceFilter', filter)
      this.localStorage.setItem('filter_devices', JSON.stringify(filter))

      this.$http.v1.getDevices(1, filter, (response) => {
        this.pages = response.data.pages
        this.next_page = response.data.next_page
        this.cur_page = response.data.current_page
        this.group_cnt = {...response.data.groups}
        this.filter_result = {devices: response.data.count, pages: response.data.pages}
        this.tableData = {...response.data.devices}

        for (let i in this.tableData) {
          for (let j in this.tableData[i]) {
            this.$set(this.tableData[i][j], 'checked', false)
          }
        }
      })
    },

    add_device_in_list () {
      this.afterload = true
      this.$http.v1.getDevices(this.next_page, {...this.filter}, (response) => {
        let tmp = {...this.tableData}
        for (let i in response.data.devices) {
          if (tmp[i] === undefined) {
            tmp[i] = {}
          }
          for (let j in response.data.devices[i]) {
            tmp[i][j] = response.data.devices[i][j]
          }
        }

        this.tableData = {...tmp}

        this.cur_page = response.data.current_page
        this.next_page = response.data.next_page
        this.group_cnt = Object.assign(this.group_cnt, {...response.data.groups})
      })
    },
    add_task () {
      let checkedList = []
      for (let i in this.tableData) {
        for (let j in this.tableData[i]) {
          if (this.tableData[i][j].checked) {
            checkedList.push(this.tableData[i][j].device_id)
          }
        }
      }
      if (checkedList.length < 1) {
        this.global_notify('danger', this.translate('device.no_chosen'))
        return false
      }

      this.$modal.show(DeviceManage, {listDevice: checkedList}, {minHeight: 500, height: 'auto', minWidth: 500, adaptive: true, clickToClose: true, scrollable: true, name: 'dynamic-modal'})
    },

    report () {
      this.loading = true
      let filter = {...this.filter }
      if(this.was_checkall) {
        filter['not_id'] = Object.keys(this.uncheckList)
      }
      else {
        let checkedList = []
        for (let i in this.tableData) {
          for (let j in this.tableData[i]) {
            if (this.tableData[i][j].checked) {
              checkedList.push(this.tableData[i][j].device_id)
            }
          }
        }
        if (checkedList.length === 0)  {
          this.global_notify('danger', this.translate('device.no_chosen'))
          this.loading = true
          return false
        } else {
          filter['ids'] = checkedList
        }
      }

    },

    toggleFiltersState () {
      this.filters_state = !this.filters_state
      this.localStorage.setItem('filters_state', this.filters_state)
    },

    check_group(parent, group, id, devs_ids, groups_for_dev_ids, groups_ids, groups_for_grp_ids){
      let new_group = {
        id: +group.id,
        expanded: false,
        hasExpanded: true,
        parent: group.parent,
        name: group.name,
        children: [],
        role: 'group'
      }
      if(groups_ids.indexOf(+group.id) > -1){
        new_group.checked = true
        new_group.children.push({ role: 'empty', visible: false, checked: true })
      }else{
        new_group.checked = false
        new_group.children.push({ role: 'empty', visible: false })
      }

      parent.children[id] = new_group

      if (groups_for_dev_ids.indexOf(parent.children[id].id) > -1 || groups_for_grp_ids.indexOf(parent.children[id].id) > -1) {
        parent.children[id].expanded = true
        this.$http.v1.getListDevicesByIdGroup({group_id: group.id}, (response) => {
          let devices = response.data
          for(let j in devices) {
            let device = {
              name: '(' + devices[j].fid + ') ' + '<b>' + devices[j].name2 + '</b>',
              id: devices[j].device_id,
              role: 'children',
              group_id: +group.id,
              fid: devices[j].fid
            }
            devs_ids.indexOf(+devices[j].device_id) > -1 ? device.checked = true : device.checked = false

            parent.children[id].children.push(device)
          }
        })
      }

      if (group.children) {
        for(let children_id in group.children) {
          this.check_group(parent.children[id], group.children[children_id], children_id, devs_ids, groups_for_dev_ids, groups_ids, groups_for_grp_ids);
        }
      }

    },

    notifications () {
      let devs_ids = []
      let groups_for_dev_ids = []
      let notice_list = {}
      notice_list.devices = []

      for (let i in this.tableData) {
        for (let j in this.tableData[i]) {
          if (this.tableData[i][j].checked) {
            devs_ids.push(this.tableData[i][j].device_id)
            groups_for_dev_ids.push(this.tableData[i][j].group_id)
            groups_for_dev_ids = groups_for_dev_ids.concat(...this.$store.getters.getPathGroupById(this.tableData[i][j].group_id))

            let new_device = {
              name: '(' + this.tableData[i][j].fid + ') ' + '<b>' + this.tableData[i][j].name2 + '</b>',
              id: this.tableData[i][j].device_id,
              role: 'children',
              group_id: +this.tableData[i][j].group_id,
              checked: true,
              fid: this.tableData[i][j].fid
            }
            notice_list.devices.push(new_device)
          }
        }
      }
      if (devs_ids.length === 0)  {
        this.global_notify('danger', this.translate('device.no_chosen'))
        this.loading = true
        return false
      }

      let groups = this.$store.getters.getDeviceGroupsTree

      let group_list = {children: []}
      for(let group_id in groups) {
        this.check_group(group_list, groups[group_id], group_id, devs_ids, groups_for_dev_ids, [], []);
      }

      var t = this.$createElement(NotificationEdit, {
        props: {
          notice: notice_list,
          list_devices: group_list.children
        }, on: {
          close: () => {this.$modal.hide('dynamic-modal') }
        }
      })
      let temp = {
        render () { return t }
      }
      this.$modal.show(temp, {}, {height: 'auto',  width: 800, adaptive: true, clickToClose: true, scrollable: true, name: 'dynamic-modal'})

    },
    custom_device_list(type){
      let devs_ids = []
      for (let i in this.tableData) {
        for (let j in this.tableData[i]) {
          if (this.tableData[i][j].checked) {
            devs_ids.push(this.tableData[i][j].device_id)
          }
        }
      }

      let t = this.$createElement(ModalCustomDeviceList, {
        props: {
          type,
          device_list: devs_ids,
          opt_custom_list: this.opt_custom_list
        }, on: {
          close: () => {this.$modal.hide('dynamic-modal') }
        }
      })
      let temp = {
        render () { return t }
      }
      this.$modal.show(temp, {}, {height: 'auto', adaptive: true, clickToClose: true, scrollable: true, name: 'dynamic-modal'})

    },
    show_settings(){
      let t = this.$createElement(ModalSettingsDeviceList, {
        props: {
          filter: this.filter
        }, on: {
          update: (new_filter) => {
            this.filter = new_filter
            this.$modal.hide('modal_settings_device_list')
          },
          close: () => {
            this.$modal.hide('modal_settings_device_list')
          }
        }
      })
      let temp = {
        render () { return t }
      }
      this.$modal.show(temp, {}, {height: 'auto', adaptive: true, clickToClose: true, scrollable: true, name: 'modal_settings_device_list'})

    }

  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css">

</style>

<style lang="scss">

  .custom_tag{
    &.uptime{
      font-size: 0.95rem;
      letter-spacing: 0.1rem;
      text-transform: uppercase;
    }
    &.sim_status{
      width: 150px;
      font-size: 0.95rem;
      letter-spacing: 0.1rem;
      text-transform: uppercase;
    }
  }

  .multiselect__tags {
      max-height: 104px;
      overflow-x: hidden;
      overflow-y: auto;
  }

  .manage_btn  {
      display: inline-block !important;
      margin-top: 10px;
      padding: 0 2px 1px 0 !important;
      white-space: normal !important;
      height: 22px;
      line-height: 18px !important;
      margin-left: 5px !important;
      border-radius: 5px !important;
  }
  .reset-filters-btn {
      display: inline-block !important;
      margin: 0;
      vertical-align: bottom;
      padding: 0 6px 2px 4px !important;
      white-space: normal !important;
      border-radius: 5px !important;
      background: #fff;
      border: 1px solid #F3BB45;
      color: #F3BB45;
      cursor: pointer;
      transition: all ease 0.2s;
      pointer-events: auto;
      float: right;
  }
  .reset-filters-btn.is--no-active {
      border: 1px solid #f3bb4500;
      background-color: #fff0;
      pointer-events: none;
      color: #ccc;
  }

  //@media all and (min-width: 1280px)  {
  //  .device-list_fiters_is--show + * > .reset-filters-btn {
  //      margin: 30px 0;
  //  }
  //}

.datepicker {
  .mx-datepicker-range {
    min-width: 0;
  }
  .mx-icon-calendar{
    display: none;
  }
  .mx-icon-clear{
    display: none;
  }
}
.wrap-device-list{
  &_row{
    display: flex;
    align-items: center;
    justify-content: space-between;

    .manage_block{
      width: 25%;
      .form-group{
        margin-bottom: 0;
      }
      .manage{
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        // flex-direction: column;
        flex-wrap: wrap;
        .manage_btns{
          width: 100%;
          margin: 2px;
          height: 22px;
          display: inline-block;
          white-space: normal;
          border-radius: 5px;
          padding: 0;
          overflow: hidden;
        }
        .datepicker{
          .btn{
            width: 100%;
            height: 22px;
            padding: 0;
          }
        }
      }
    }
    .device_groups{
      width: 20%;
    }
    .users_list{
      width: 20%;
    }
    .versions_list{
      width: 20%;
    }
  }
  .reset-filters-wrap{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-direction: column;
    width: 10%;
    &--hidden{
      display: none;
    }
    button{
      margin-bottom: 10px;
      &:last-child{
        margin-bottom: 0;
      }
    }
    .mdi-file-excel{
      padding: 0 10px;
      margin-bottom: 10px;
      border: 1px solid;
    }
  }
  .response_table{
    padding: 0;
    .checkbox_table{
      width: 30px;
      height: 50px;
      span{
        display: block;
        font-size: 12px;
        line-height: normal;
        text-align: center;
      }
    }
    .group_res{
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      span{
        min-width: 250px;
      }
      .client{
        text-align: right;
      }
      &:hover{
        background-color: #d5d5d5
      }
    }
    .device_item{
      cursor: pointer;
      &:hover{
        background-color: #eee;
        color: black;
        tr{
          background-color: #f1f1f1;
        }
      }
    }
  }
}

@media (max-width: 1366px) {
  .custom_tag{
    &.sim_status{
      width: 110px;
    }
  }
}

@media (max-width: 767px)  {
  .wrap-device-list {
    &_row{
      flex-direction: column;
      .manage_block{
        width: 90%;
        margin-bottom: 10px;
      }
      .device_groups{
        width: 90%;
      }
      .users_list{
        width: 90%;
      }
      .versions_list{
        width: 90%;
      }
    }
    .reset-filters-wrap{
      width: 90%;
      display: inline-flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
      .mdi{
        margin: 0;
      }
    }
    .reset-filters-btn.is--no-active {
        background-color: #f1eae0;
        border-color: #f1eae0;
    }
  }
  .response_table{
    margin: 0 -2px;
    &>table{
      thead.table-device-list_bg{
        padding: 10px 0;
        border: none;
        height: 80px;
        margin: auto;
        position: relative;
        overflow: visible;
        width: 100%;

        tr {
          display: block;
          border: none;
          margin: 0;
          padding: 0;
        }
        th {
          display: none;
          &.table-device-list_mob-filters {
            display: inline-block;
            width: 33%;
            height: 40px;
            z-index: 1;
          }
        }
      }
    }
  }
}
</style>
